<template>
  <header class="cd-morph-dropdown" role="navigation">
    <a href="#0" class="nav-trigger"
      >Open Nav<span aria-hidden="true"></span
    ></a>

    <nav
      class="navbar-fixed-top navbar-dark fixed-top main-nav"
      id="surfverse-appbar"
      :class="{
        'router-home': $route.fullPath === '',
        'router-engineering': $route.fullPath === '/engineering',
        'router-about': $route.fullPath === '/about',
        'router-design': $route.fullPath === '/design',
        'router-changelog': $route.fullPath === '/changelog'
      }"
    >
      <div class="navbar navbar-expand-lg">
        <router-link class="nav-link navbar-brand" to="/"
          >Surfverse</router-link
        >
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mx-auto">
            <li class="has-dropdown gallery nav-item" data-content="about">
              <router-link class="nav-link" to="/products">{{
                $t('products')
              }}</router-link>
            </li>

            <li class="has-dropdown links nav-item" data-content="pricing">
              <router-link class="nav-link" to="/services">{{
                $t('services')
              }}</router-link>
            </li>

            <li class="has-dropdown button nav-item" data-content="contact">
              <router-link class="nav-link" to="/company">{{
                $t('company')
              }}</router-link>
            </li>

            <li class="has-dropdown button nav-item" data-content="contact">
              <router-link class="nav-link" to="/pricing">{{
                $t('pricing')
              }}</router-link>
            </li>
          </ul>
          <dark-mode-toggle
            data-toggle="tooltip"
            data-placement="bottom"
            title="Theme switcher"
            permanent="true"
            appearance="toggle"
          ></dark-mode-toggle>
          <button
            href="#footer"
            class="mdc-button mdc-beta mdc-button--unelevated my-2 my-sm-0"
            data-toggle="modal"
            data-target="#exampleModal"
          >
            {{ $t('feature.beta') }}
          </button>
        </div>
      </div>
    </nav>

    <div class="morph-dropdown-wrapper">
      <div class="dropdown-list">
        <ul>
          <li id="about" class="dropdown gallery">
            <a href="#0" class="label">About</a>

            <div class="content">
              <ul>
                <li>
                  <a href="#0">
                    <em>Title here</em>
                    <span>A brief description here</span>
                  </a>
                </li>

                <li>
                  <a href="#0">
                    <em>Title here</em>
                    <span>A brief description here</span>
                  </a>
                </li>

                <li>
                  <a href="#0">
                    <em>Title here</em>
                    <span>A brief description here</span>
                  </a>
                </li>

                <li>
                  <a href="#0">
                    <em>Title here</em>
                    <span>A brief description here</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>

          <li id="pricing" class="dropdown links">
            <a href="#0" class="label">Pricing</a>

            <div class="content">
              <ul>
                <li>
                  <h2>Services</h2>

                  <ul class="links-list">
                    <li><a href="#0">Logo Design</a></li>
                    <li><a href="#0">Branding</a></li>
                    <li><a href="#0">Web Design</a></li>
                    <li><a href="#0">iOS</a></li>
                    <li><a href="#0">Android</a></li>
                    <li><a href="#0">HTML/CSS/JS</a></li>
                    <li><a href="#0">Packaging</a></li>
                    <li><a href="#0">Mobile</a></li>
                    <li><a href="#0">UI/UX</a></li>
                    <li><a href="#0">Prototyping</a></li>
                  </ul>
                </li>

                <li>
                  <h2>Projects</h2>

                  <ul class="links-list">
                    <li><a href="#0">Logo Design</a></li>
                    <li><a href="#0">Branding</a></li>
                    <li><a href="#0">Web Design</a></li>
                    <li><a href="#0">iOS</a></li>
                    <li><a href="#0">Android</a></li>
                    <li><a href="#0">HTML/CSS/JS</a></li>
                  </ul>
                </li>
              </ul>
            </div>
          </li>

          <li id="contact" class="dropdown button">
            <a href="#0" class="label">Contact</a>

            <div class="content">
              <ul class="links-list">
                <li><a href="#0">Link #1</a></li>
                <li><a href="#0">Link #2</a></li>
                <li><a href="#0">Link #3</a></li>
                <li><a href="#0">Link #4</a></li>
                <li><a href="#0">Link #5</a></li>
                <li><a href="#0">Link #6</a></li>
              </ul>

              <a href="#0" class="btn">Get in Touch</a>
            </div>
          </li>
        </ul>

        <div class="bg-layer" aria-hidden="true"></div>
      </div>
      <!-- dropdown-list -->
    </div>
    <!-- morph-dropdown-wrapper -->
  </header>
</template>
<script>
// import i18n from '@/components/i18n.vue'
import $ from 'jquery'

export default {
  name: 'Navbar',
  created() {
    const locale = localStorage.getItem('locale')

    if (locale) {
      this.$i18n.locale = locale
    } else if (navigator.language) {
      this.$i18n.locale = navigator.language.substring(0, 2)
    }
  },
  computed: {
    lightModeClass() {
      return { light: !!this.$route.meta?.lightMode }
    }
  }
}
</script>
<script>
jQuery(document).ready(function($) {
  function morphDropdown(element) {
    this.element = element
    this.mainNavigation = this.element.find('.main-nav')
    this.navbar = this.element.find('.navbar-fixed-top')
    this.mainNavigationItems = this.mainNavigation.find('.has-dropdown')
    this.dropdownList = this.element.find('.dropdown-list')
    this.dropdownWrappers = this.dropdownList.find('.dropdown')
    this.dropdownItems = this.dropdownList.find('.content')
    this.dropdownBg = this.dropdownList.find('.bg-layer')
    this.mq = this.checkMq()
    this.bindEvents()
  }

  // Toggle class for navbar background on scroll
  $(function() {
    $(document).scroll(function() {
      var $nav = $('.navbar-fixed-top')
      $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height())
    })
  })

  // Add tooltip
  $(function() {
    $('[data-toggle="tooltip"]').tooltip()
  })

  morphDropdown.prototype.checkMq = function() {
    //check screen size
    var self = this
    return window
      .getComputedStyle(self.element.get(0), '::before')
      .getPropertyValue('content')
      .replace(/'/g, '')
      .replace(/"/g, '')
      .split(', ')
  }

  morphDropdown.prototype.bindEvents = function() {
    var self = this
    //hover over an item in the main navigation
    this.mainNavigationItems
      .mouseenter(function(event) {
        //hover over one of the nav items -> show dropdown
        self.showDropdown($(this))
      })
      .mouseleave(function() {
        setTimeout(function() {
          //if not hovering over a nav item or a dropdown -> hide dropdown
          if (
            self.mainNavigation.find('.has-dropdown:hover').length == 0 &&
            self.element.find('.dropdown-list:hover').length == 0
          )
            self.hideDropdown()
        }, 50)
      })

    //hover over the dropdown
    this.dropdownList.mouseleave(function() {
      setTimeout(function() {
        //if not hovering over a dropdown or a nav item -> hide dropdown
        self.mainNavigation.find('.has-dropdown:hover').length == 0 &&
          self.element.find('.dropdown-list:hover').length == 0 &&
          self.hideDropdown()
      }, 50)
    })

    //click on an item in the main navigation -> open a dropdown on a touch device
    this.mainNavigationItems.on('touchstart', function(event) {
      var selectedDropdown = self.dropdownList.find(
        '#' + $(this).data('content')
      )
      if (
        !self.element.hasClass('is-dropdown-visible') ||
        !selectedDropdown.hasClass('active')
      ) {
        event.preventDefault()
        self.showDropdown($(this))
      }
    })

    //on small screens, open navigation clicking on the menu icon
    this.element.on('click', '.nav-trigger', function(event) {
      event.preventDefault()
      self.element.toggleClass('nav-open')
    })
  }

  morphDropdown.prototype.showDropdown = function(item) {
    this.mq = this.checkMq()
    if (this.mq == 'desktop') {
      var self = this
      var selectedDropdown = this.dropdownList.find('#' + item.data('content')),
        selectedDropdownHeight = selectedDropdown.innerHeight(),
        selectedDropdownWidth = selectedDropdown
          .children('.content')
          .innerWidth(),
        selectedDropdownLeft =
          item.offset().left + item.innerWidth() / 2 - selectedDropdownWidth / 2

      //update dropdown position and size
      this.updateDropdown(
        selectedDropdown,
        parseInt(selectedDropdownHeight),
        selectedDropdownWidth,
        parseInt(selectedDropdownLeft)
      )
      //add active class to the proper dropdown item
      this.element.find('.active').removeClass('active')
      selectedDropdown
        .addClass('active')
        .removeClass('move-left move-right')
        .prevAll()
        .addClass('move-left')
        .end()
        .nextAll()
        .addClass('move-right')
      item.addClass('active')
      //show the dropdown wrapper if not visible yet
      if (!this.element.hasClass('is-dropdown-visible')) {
        setTimeout(function() {
          self.element.addClass('is-dropdown-visible')
        }, 10)
      }
    }
  }

  morphDropdown.prototype.updateDropdown = function(
    dropdownItem,
    height,
    width,
    left
  ) {
    this.dropdownList.css({
      '-moz-transform': 'translateX(' + left + 'px)',
      '-webkit-transform': 'translateX(' + left + 'px)',
      '-ms-transform': 'translateX(' + left + 'px)',
      '-o-transform': 'translateX(' + left + 'px)',
      transform: 'translateX(' + left + 'px)',
      width: width + 'px',
      height: height + 'px'
    })

    this.dropdownBg.css({
      '-moz-transform': 'scaleX(' + width + ') scaleY(' + height + ')',
      '-webkit-transform': 'scaleX(' + width + ') scaleY(' + height + ')',
      '-ms-transform': 'scaleX(' + width + ') scaleY(' + height + ')',
      '-o-transform': 'scaleX(' + width + ') scaleY(' + height + ')',
      transform: 'scaleX(' + width + ') scaleY(' + height + ')'
    })
  }

  morphDropdown.prototype.hideDropdown = function() {
    this.mq = this.checkMq()
    if (this.mq == 'desktop') {
      this.element
        .removeClass('is-dropdown-visible')
        .find('.active')
        .removeClass('active')
        .end()
        .find('.move-left')
        .removeClass('move-left')
        .end()
        .find('.move-right')
        .removeClass('move-right')
    }
  }

  morphDropdown.prototype.resetDropdown = function() {
    this.mq = this.checkMq()
    if (this.mq == 'mobile') {
      this.dropdownList.removeAttr('style')
    }
  }

  var morphDropdowns = []
  if ($('.cd-morph-dropdown').length > 0) {
    $('.cd-morph-dropdown').each(function() {
      //create a morphDropdown object for each .cd-morph-dropdown
      morphDropdowns.push(new morphDropdown($(this)))
    })

    var resizing = false

    //on resize, reset dropdown style property
    updateDropdownPosition()
    $(window).on('resize', function() {
      if (!resizing) {
        resizing = true
        !window.requestAnimationFrame
          ? setTimeout(updateDropdownPosition, 300)
          : window.requestAnimationFrame(updateDropdownPosition)
      }
    })

    function updateDropdownPosition() {
      morphDropdowns.forEach(function(element) {
        element.resetDropdown()
      })

      resizing = false
    }
  }
})
</script>

<style>
/* .mdc-beta {
  background-color: #e8b10b !important;
  color: #000 !important;
} */
.mdc-beta {
  border-radius: 50px;
  color: var(--beta-button-text) !important;
  background-color: var(--beta-button-bg) !important;
  box-shadow: -2px 2px 4px 0 rgba(0, 0, 0, 0.3),
    2px -2px 6px rgba(255, 255, 255, 0.25);
  background: linear-gradient(
    -45deg,
    rgba(0, 0, 0, 0.22),
    rgba(255, 255, 255, 0.25)
  );
}

.navbar-fixed-top.scrolled {
  backdrop-filter: saturate(180%) blur(20px);
  /* // background-color: rgba(255,255,255,0.7);
  // background-color: rgba(0,0,0,0.8); */
  background-color: var(--navbar-bg) !important;
  border-bottom: 1px solid var(--navbar-border-bottom);
  -webkit-transition: background-color 0.5s cubic-bezier(0.28, 0.11, 0.32, 1);
  transition: background-color 0.5s cubic-bezier(0.28, 0.11, 0.32, 1);
}

/* .navbar-fixed-top.scrolled .nav-link {
  color: #555;
} */
.navbar-dark .navbar-nav .nav-link {
  color: var(--text-color-nav);
}
.nav-item {
  font-family: Roboto;
  letter-spacing: 1px;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
}
.navbar-toggler {
  color: var(--text-color);
  display: flex;
  align-items: center;
  justify-content: center;
}
.navbar-toggler-icon {
  display: flex;
  justify-content: center;
  background-color: var(--text-color);
  /* -webkit-mask-image: url(/img/menu.svg);
  mask-image: url(/img/menu.svg); */
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  width: 24px;
  height: 24px;
}
.dropdown-menu.show {
  animation: dropdown-anim 0.4s cubic-bezier(0.73, 0.005, 0.22, 1);
}
@keyframes dropdown-anim {
  0% {
    opacity: 0;
    transform: scale(0.98) translateY(-0.6em);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
</style>
<style>
/* -------------------------------- 

 Header

-------------------------------- */
.cd-morph-dropdown {
  position: relative;
  height: 60px;
  background-color: #ffffff;
}
.cd-morph-dropdown::before {
  /* never visible - used in JS to check mq */
  content: 'mobile';
  display: none;
}
.cd-morph-dropdown .nav-trigger {
  /* menu icon - visible on small screens only */
  position: absolute;
  top: 0;
  right: 0;
  height: 60px;
  width: 60px;
  /* replace text with icon */
  overflow: hidden;
  text-indent: 100%;
  white-space: nowrap;
  color: transparent;
}
.cd-morph-dropdown .nav-trigger span,
.cd-morph-dropdown .nav-trigger span::after,
.cd-morph-dropdown .nav-trigger span::before {
  /* these are the 3 lines of the menu icon */
  position: absolute;
  background-color: #1a1a1a;
  height: 3px;
  width: 26px;
}
.cd-morph-dropdown .nav-trigger span {
  left: 50%;
  top: 50%;
  bottom: auto;
  right: auto;
  -webkit-transform: translateX(-50%) translateY(-50%);
  -ms-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  -webkit-transition: background-color 0.3s;
  transition: background-color 0.3s;
}
.cd-morph-dropdown .nav-trigger span::after,
.cd-morph-dropdown .nav-trigger span::before {
  content: '';
  left: 0;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
}
.cd-morph-dropdown .nav-trigger span::before {
  -webkit-transform: translateY(-9px);
  -ms-transform: translateY(-9px);
  transform: translateY(-9px);
}
.cd-morph-dropdown .nav-trigger span::after {
  -webkit-transform: translateY(9px);
  -ms-transform: translateY(9px);
  transform: translateY(9px);
}
.cd-morph-dropdown.nav-open .nav-trigger span {
  background-color: transparent;
}
.cd-morph-dropdown.nav-open .nav-trigger span::before {
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.cd-morph-dropdown.nav-open .nav-trigger span::after {
  -webkit-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.cd-morph-dropdown .main-nav {
  display: none;
}
.cd-morph-dropdown .morph-dropdown-wrapper {
  display: none;
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  padding: 1.2em 5%;
  box-shadow: inset 0 1px 0 #e6e6e6;
  background-color: #ffffff;
}
.cd-morph-dropdown.nav-open .morph-dropdown-wrapper {
  display: block;
}
.cd-morph-dropdown .dropdown-list > ul > li {
  margin-bottom: 3.3em;
}
.cd-morph-dropdown .label {
  display: block;
  font-size: 2.2rem;
  color: #1a1a1a;
  margin-bottom: 0.8em;
}
.cd-morph-dropdown .content li::after {
  clear: both;
  content: '';
  display: block;
}
.cd-morph-dropdown .gallery .content li {
  margin-bottom: 1.4em;
}
.cd-morph-dropdown .gallery .content a {
  display: block;
}
.cd-morph-dropdown .gallery .content a::before {
  /* icon on the left */
  content: '';
  display: inline-block;
  float: left;
  height: 54px;
  width: 54px;
  margin-right: 0.6em;
  background: red;
  border-radius: 50%;
  -webkit-transition: background 0.2s;
  transition: background 0.2s;
}
.cd-morph-dropdown .gallery .content a span,
.cd-morph-dropdown .gallery .content a em {
  display: block;
  line-height: 1.2;
}
.cd-morph-dropdown .gallery .content a em {
  font-size: 1.8rem;
  padding: 0.4em 0 0.2em;
  color: #1a1a1a;
}
.cd-morph-dropdown .gallery .content a span {
  font-size: 1.4rem;
  color: #a6a6a6;
}
.cd-morph-dropdown .gallery .content a:hover::before {
  background-color: #1a1a1a;
}
/* .cd-morph-dropdown .gallery li:nth-of-type(1) a::before {
  background: #f4e58a url(../img/cd-gallery-icons.svg) no-repeat 0 0;
}
.cd-morph-dropdown .gallery li:nth-of-type(2) a::before {
  background: #f4af6d url(../img/cd-gallery-icons.svg) no-repeat -54px 0;
}
.cd-morph-dropdown .gallery li:nth-of-type(3) a::before {
  background: #db6356 url(../img/cd-gallery-icons.svg) no-repeat -108px 0;
}
.cd-morph-dropdown .gallery li:nth-of-type(4) a::before {
  background: #8d4645 url(../img/cd-gallery-icons.svg) no-repeat -162px 0;
} */
.cd-morph-dropdown .links .content > ul > li {
  margin-top: 1em;
}
.cd-morph-dropdown .links-list a,
.cd-morph-dropdown .btn {
  display: block;
  margin-left: 14px;
  font-size: 2.2rem;
  line-height: 1.6;
}
.cd-morph-dropdown .links-list a:hover,
.cd-morph-dropdown .btn:hover {
  color: #1a1a1a;
}
.cd-morph-dropdown .content h2 {
  color: #a6a6a6;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 1.3rem;
  margin: 20px 0 10px 14px;
}
@media only screen and (min-width: 1000px) {
  .cd-morph-dropdown {
    position: absolute;
    height: 80px;
    left: 0;
    top: 0;
    width: 100%;
    padding: 0;
    text-align: center;
    background-color: transparent;
  }
  .cd-morph-dropdown::before {
    content: 'desktop';
  }
  .cd-morph-dropdown .nav-trigger {
    display: none;
  }
  .cd-morph-dropdown .main-nav {
    display: inline-block;
  }
  .cd-morph-dropdown .main-nav > ul > li {
    display: inline-block;
    float: left;
  }
  .cd-morph-dropdown .main-nav > ul > li > a {
    display: block;
    padding: 0 1.8em;
    height: 70px;
    line-height: 70px;
    color: #ffffff;
    font-size: 1.8rem;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-transition: opacity 0.2s;
    transition: opacity 0.2s;
  }
  .cd-morph-dropdown.is-dropdown-visible .main-nav > ul > li > a {
    /* main navigation hover effect - on hover, reduce opacity of elements not hovered over */
    opacity: 0.6;
  }
  .cd-morph-dropdown.is-dropdown-visible .main-nav > ul > li.active > a {
    opacity: 1;
  }
  .cd-morph-dropdown .morph-dropdown-wrapper {
    /* dropdown wrapper - used to create the slide up/slide down effect when dropdown is revealed/hidden */
    display: block;
    position: fixed;
    top: 58px;
    /* overwrite mobile style */
    width: auto;
    z-index: 1000;
    padding: 0;
    box-shadow: none;
    background-color: transparent;
    /* Force Hardware acceleration */
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    will-change: transform;
    -webkit-transform: translateY(20px);
    -ms-transform: translateY(20px);
    transform: translateY(20px);
    -webkit-transition: -webkit-transform 0.3s;
    transition: -webkit-transform 0.3s;
    transition: transform 0.3s;
    transition: transform 0.3s, -webkit-transform 0.3s;
  }
  .cd-morph-dropdown.is-dropdown-visible .morph-dropdown-wrapper {
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
  }
  .cd-morph-dropdown .dropdown-list {
    position: absolute;
    top: 0;
    left: 0;
    visibility: hidden;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    will-change: transform, width, height;
    -webkit-transition: visibility 0.3s;
    transition: visibility 0.3s;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
  }
  .no-csstransitions .cd-morph-dropdown .dropdown-list {
    display: none;
  }
  .cd-morph-dropdown .dropdown-list::before {
    /* dropdown top triangle */
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    right: auto;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    height: 0;
    width: 0;
    border: 8px solid transparent;
    border-bottom-color: #ffffff;
    opacity: 0;
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s;
  }
  .cd-morph-dropdown .dropdown-list > ul {
    position: relative;
    z-index: 1;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
  .cd-morph-dropdown.is-dropdown-visible .dropdown-list {
    visibility: visible;
    -webkit-transition: width 0.3s, height 0.3s, -webkit-transform 0.3s;
    transition: width 0.3s, height 0.3s, -webkit-transform 0.3s;
    transition: transform 0.3s, width 0.3s, height 0.3s;
    transition: transform 0.3s, width 0.3s, height 0.3s, -webkit-transform 0.3s;
  }
  .cd-morph-dropdown.is-dropdown-visible .dropdown-list::before {
    opacity: 1;
  }
  .cd-morph-dropdown .dropdown {
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    visibility: hidden;
    width: 100%;
    -webkit-transition: opacity 0.3s, visibility 0.3s;
    transition: opacity 0.3s, visibility 0.3s;
  }
  .cd-morph-dropdown .dropdown.active {
    opacity: 1;
    visibility: visible;
  }
  .cd-morph-dropdown .dropdown.move-left .content {
    -webkit-transform: translateX(-100px);
    -ms-transform: translateX(-100px);
    transform: translateX(-100px);
  }
  .cd-morph-dropdown .dropdown.move-right .content {
    -webkit-transform: translateX(100px);
    -ms-transform: translateX(100px);
    transform: translateX(100px);
  }
  .cd-morph-dropdown .label {
    /* hide the label on bigger devices */
    display: none;
  }
  .cd-morph-dropdown .content {
    padding: 2.2em 1.8em;
    -webkit-transition: -webkit-transform 0.3s;
    transition: -webkit-transform 0.3s;
    transition: transform 0.3s;
    transition: transform 0.3s, -webkit-transform 0.3s;
    text-align: left;
  }
  .cd-morph-dropdown .content > ul::after {
    clear: both;
    content: '';
    display: block;
  }
  .cd-morph-dropdown .content > ul > li {
    width: 48%;
    float: left;
    margin-right: 4%;
    margin-top: 0;
  }
  .cd-morph-dropdown .content > ul > li:nth-of-type(2n) {
    margin-right: 0;
  }
  .cd-morph-dropdown .gallery .content {
    /* you need to set a width for the .content elements because they have a position absolute */
    width: 510px;
    padding-bottom: 0.8em;
  }
  .cd-morph-dropdown .gallery .content li {
    margin-bottom: 1.8em;
  }
  .cd-morph-dropdown .links .content > ul > li {
    margin-top: 0;
  }
  .cd-morph-dropdown .links .content,
  .cd-morph-dropdown .button .content {
    width: 390px;
  }
  .cd-morph-dropdown .links-list a {
    font-size: 1.6rem;
    margin-left: 0;
  }
  .cd-morph-dropdown .btn {
    display: block;
    width: 100%;
    height: 60px;
    margin: 1.5em 0 0;
    font-size: 1.8rem;
    text-align: center;
    color: #ffffff;
    line-height: 60px;
    background: #db6356;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .cd-morph-dropdown .btn:hover {
    background: #1a1a1a;
    color: #ffffff;
  }
  .cd-morph-dropdown .content h2 {
    font-size: 1.8rem;
    text-transform: none;
    font-weight: normal;
    color: #1a1a1a;
    margin: 0 0 0.6em;
  }
  .cd-morph-dropdown .bg-layer {
    /* morph dropdown background */
    position: absolute;
    top: 0;
    left: 0;
    height: 1px;
    width: 1px;
    background: #f2f2f2;
    opacity: 0;
    border-radius: 20px;
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s;
    -webkit-transform-origin: top left;
    -ms-transform-origin: top left;
    transform-origin: top left;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    will-change: transform;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }
  .cd-morph-dropdown.is-dropdown-visible .bg-layer {
    border-radius: 20px;
    opacity: 1;
    -webkit-transition: opacity 0.3s, -webkit-transform 0.3s;
    transition: opacity 0.3s, -webkit-transform 0.3s;
    transition: transform 0.3s, opacity 0.3s;
    transition: transform 0.3s, opacity 0.3s, -webkit-transform 0.3s;
  }
}
</style>
<i18n>
{
  "en": {
    "overview": "The App",
    "pricing": "Pricing",
    "work": "Work",
    "subscribe": "Subscribe",
    "english": "English",
    "romanian": "Romanian",
    "german": "German",
    "company": "Company",
    "developers": "Developers",
    "tech": "Engineering",
    "changelog": "Changelog",
    "design": "Design",
    "features": "All features",
    "feature": {
      "darkmode": "Dark Mode",
      "privacy": "Privacy and Security",
      "profiles": "Profiles",
      "maps": "Maps",
      "favorites": "Favorites",
      "search": "Searching",
      "messages": "Messages",
      "photos": "Photos",
      "trending": "Trending",
      "radar": "Radar",
      "developers": "Developers",
      "studio": "Studio",
      "faq": "F.A.Q",
      "beta": "Get Early Access"
    }
  },
  "ro": {
    "overview": "The App",
    "pricing": "Preturi",
    "work": "Proiecte",
    "subscribe": "Abonează-te",
    "english": "Engleză",
    "romanian": "Română",
    "german": "Germană",
    "company": "Companie",
    "developers": "Dezvoltatori",
    "tech": "Tehnologie",
    "changelog": "Actualizări",
    "design": "Design",
    "features": "Toate Caracteristicile",
    "feature": {
      "darkmode": "Modul Întunecat",
      "privacy": "Confidențialitate și securitate",
      "profiles": "Profile",
      "maps": "Hărți",
      "favorites": "Favorite",
      "search": "Căutare vocală",
      "messages": "Mesage",
      "photos": "Fotografii",
      "trending": "Tendințe",
      "radar": "Radar",
      "developers": "Dezvoltatori",
      "studio": "Studio",
      "faq": "Întrebări frecvente",
      "beta": "Obțineți acces timpuriu"
    }
  },
  "de": {
    "overview": "The App",
    "pricing": "Pricing",
    "subscribe": "Abonnieren",
    "english": "Englisch",
    "romanian": "Rumänisch",
    "german": "Deutsch",
    "company": "Unternehmen",
    "developers": "Entwicklerinnen",
    "tech": "Technologie",
    "changelog": "Changelog",
    "design": "Design",
    "features": "Alle Features",
    "feature": {
      "darkmode": "Dark Mode",
      "privacy": "Privacy and Security",
      "profiles": "Profiles",
      "maps": "Maps",
      "favorites": "Favorites",
      "search": "Searching",
      "messages": "Messages",
      "photos": "Photos",
      "trending": "Trending",
      "radar": "Radar",
      "developers": "Developers",
      "studio": "Studio",
      "faq": "FAQ",
      "beta": "Erhalten Sie frühzeitigen Zugang"
    }
  }
}
</i18n>
